import { render, staticRenderFns } from "./itemDigital.vue?vue&type=template&id=95468078&scoped=true&"
import script from "./itemDigital.vue?vue&type=script&lang=js&"
export * from "./itemDigital.vue?vue&type=script&lang=js&"
import style0 from "./itemDigital.vue?vue&type=style&index=0&id=95468078&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95468078",
  null
  
)

export default component.exports